import C, { useRef as M, useCallback as N, useState as B, useContext as _, useEffect as V, useMemo as te, forwardRef as it, createContext as he } from "react";
import { flushSync as kt } from "react-dom";
function ot(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (r = ot(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function It() {
  for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = ot(e)) && (n && (n += " "), n += t);
  return n;
}
const ue = typeof document < "u" ? C.useLayoutEffect : () => {
};
function G(e) {
  const t = M(null);
  return ue(() => {
    t.current = e;
  }, [
    e
  ]), N((...r) => {
    const n = t.current;
    return n == null ? void 0 : n(...r);
  }, []);
}
const ve = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, at = /* @__PURE__ */ C.createContext(ve), Kt = /* @__PURE__ */ C.createContext(!1);
let Nt = !!(typeof window < "u" && window.document && window.document.createElement), we = /* @__PURE__ */ new WeakMap();
function Ht(e = !1) {
  let t = _(at), r = M(null);
  if (r.current === null && !e) {
    var n, i;
    let s = (i = C.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (n = i.ReactCurrentOwner) === null || n === void 0 ? void 0 : n.current;
    if (s) {
      let l = we.get(s);
      l == null ? we.set(s, {
        id: t.current,
        state: s.memoizedState
      }) : s.memoizedState !== l.state && (t.current = l.id, we.delete(s));
    }
    r.current = ++t.current;
  }
  return r.current;
}
function At(e) {
  let t = _(at);
  t === ve && !Nt && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let r = Ht(!!e), n = t === ve && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${n}-${r}`;
}
function Vt(e) {
  let t = C.useId(), [r] = B(st()), n = r || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ve.prefix}`;
  return e || `${n}-${t}`;
}
const Rt = typeof C.useId == "function" ? Vt : At;
function Ut() {
  return !1;
}
function jt() {
  return !0;
}
function Wt(e) {
  return () => {
  };
}
function st() {
  return typeof C.useSyncExternalStore == "function" ? C.useSyncExternalStore(Wt, Ut, jt) : _(Kt);
}
let Gt = !!(typeof window < "u" && window.document && window.document.createElement), J = /* @__PURE__ */ new Map(), ne;
typeof FinalizationRegistry < "u" && (ne = new FinalizationRegistry((e) => {
  J.delete(e);
}));
function ae(e) {
  let [t, r] = B(e), n = M(null), i = Rt(t), s = M(null);
  if (ne && ne.register(s, i), Gt) {
    const l = J.get(i);
    l && !l.includes(n) ? l.push(n) : J.set(i, [
      n
    ]);
  }
  return ue(() => {
    let l = i;
    return () => {
      ne && ne.unregister(s), J.delete(l);
    };
  }, [
    i
  ]), V(() => {
    let l = n.current;
    return l && r(l), () => {
      l && (n.current = null);
    };
  }), i;
}
function Bt(e, t) {
  if (e === t) return e;
  let r = J.get(e);
  if (r)
    return r.forEach((i) => i.current = t), t;
  let n = J.get(t);
  return n ? (n.forEach((i) => i.current = e), e) : t;
}
function lt(...e) {
  return (...t) => {
    for (let r of e) typeof r == "function" && r(...t);
  };
}
const F = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, k = (e) => e && "window" in e && e.window === e ? e : F(e).defaultView || window;
function _t(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function zt(e) {
  return _t(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let Xt = !1;
function Ae() {
  return Xt;
}
function T(e, t) {
  if (!Ae()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let r = t;
  for (; r !== null; ) {
    if (r === e) return !0;
    r.tagName === "SLOT" && r.assignedSlot ? r = r.assignedSlot.parentNode : zt(r) ? r = r.host : r = r.parentNode;
  }
  return !1;
}
const se = (e = document) => {
  var t;
  if (!Ae()) return e.activeElement;
  let r = e.activeElement;
  for (; r && "shadowRoot" in r && (!((t = r.shadowRoot) === null || t === void 0) && t.activeElement); ) r = r.shadowRoot.activeElement;
  return r;
};
function m(e) {
  return Ae() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
function U(...e) {
  let t = {
    ...e[0]
  };
  for (let r = 1; r < e.length; r++) {
    let n = e[r];
    for (let i in n) {
      let s = t[i], l = n[i];
      typeof s == "function" && typeof l == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? t[i] = lt(s, l) : (i === "className" || i === "UNSAFE_className") && typeof s == "string" && typeof l == "string" ? t[i] = It(s, l) : i === "id" && s && l ? t.id = Bt(s, l) : t[i] = l !== void 0 ? l : s;
    }
  }
  return t;
}
function Yt(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    for (let r of e)
      typeof r == "function" ? r(t) : r != null && (r.current = t);
  };
}
const qt = /* @__PURE__ */ new Set([
  "id"
]), Zt = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Jt = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Qt = /^(data-.*)$/;
function Ve(e, t = {}) {
  let { labelable: r, isLink: n, propNames: i } = t, s = {};
  for (const l in e) Object.prototype.hasOwnProperty.call(e, l) && (qt.has(l) || r && Zt.has(l) || n && Jt.has(l) || i != null && i.has(l) || Qt.test(l)) && (s[l] = e[l]);
  return s;
}
function Q(e) {
  if (er()) e.focus({
    preventScroll: !0
  });
  else {
    let t = tr(e);
    e.focus(), rr(t);
  }
}
let de = null;
function er() {
  if (de == null) {
    de = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return de = !0, !0;
        }
      });
    } catch {
    }
  }
  return de;
}
function tr(e) {
  let t = e.parentNode, r = [], n = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== n; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && r.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return n instanceof HTMLElement && r.push({
    element: n,
    scrollTop: n.scrollTop,
    scrollLeft: n.scrollLeft
  }), r;
}
function rr(e) {
  for (let { element: t, scrollTop: r, scrollLeft: n } of e)
    t.scrollTop = r, t.scrollLeft = n;
}
function Ee(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function Re(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function j(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const ee = j(function() {
  return Re(/^Mac/i);
}), nr = j(function() {
  return Re(/^iPhone/i);
}), ut = j(function() {
  return Re(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  ee() && navigator.maxTouchPoints > 1;
}), Ue = j(function() {
  return nr() || ut();
});
j(function() {
  return ee() || Ue();
});
const ir = j(function() {
  return Ee(/AppleWebKit/i) && !or();
}), or = j(function() {
  return Ee(/Chrome/i);
}), ct = j(function() {
  return Ee(/Android/i);
}), ar = j(function() {
  return Ee(/Firefox/i);
});
function le(e, t, r = !0) {
  var n, i;
  let { metaKey: s, ctrlKey: l, altKey: u, shiftKey: c } = t;
  ar() && (!((i = window.event) === null || i === void 0 || (n = i.type) === null || n === void 0) && n.startsWith("key")) && e.target === "_blank" && (ee() ? s = !0 : l = !0);
  let f = ir() && ee() && !ut() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: s,
    ctrlKey: l,
    altKey: u,
    shiftKey: c
  }) : new MouseEvent("click", {
    metaKey: s,
    ctrlKey: l,
    altKey: u,
    shiftKey: c,
    bubbles: !0,
    cancelable: !0
  });
  le.isOpening = r, Q(e), e.dispatchEvent(f), le.isOpening = !1;
}
le.isOpening = !1;
let q = /* @__PURE__ */ new Map(), Ce = /* @__PURE__ */ new Set();
function _e() {
  if (typeof window > "u") return;
  function e(n) {
    return "propertyName" in n;
  }
  let t = (n) => {
    if (!e(n) || !n.target) return;
    let i = q.get(n.target);
    i || (i = /* @__PURE__ */ new Set(), q.set(n.target, i), n.target.addEventListener("transitioncancel", r, {
      once: !0
    })), i.add(n.propertyName);
  }, r = (n) => {
    if (!e(n) || !n.target) return;
    let i = q.get(n.target);
    if (i && (i.delete(n.propertyName), i.size === 0 && (n.target.removeEventListener("transitioncancel", r), q.delete(n.target)), q.size === 0)) {
      for (let s of Ce) s();
      Ce.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", r);
}
typeof document < "u" && (document.readyState !== "loading" ? _e() : document.addEventListener("DOMContentLoaded", _e));
function dt(e) {
  requestAnimationFrame(() => {
    q.size === 0 ? e() : Ce.add(e);
  });
}
function je() {
  let e = M(/* @__PURE__ */ new Map()), t = N((i, s, l, u) => {
    let c = u != null && u.once ? (...f) => {
      e.current.delete(l), l(...f);
    } : l;
    e.current.set(l, {
      type: s,
      eventTarget: i,
      fn: c,
      options: u
    }), i.addEventListener(s, c, u);
  }, []), r = N((i, s, l, u) => {
    var c;
    let f = ((c = e.current.get(l)) === null || c === void 0 ? void 0 : c.fn) || l;
    i.removeEventListener(s, f, u), e.current.delete(l);
  }, []), n = N(() => {
    e.current.forEach((i, s) => {
      r(i.eventTarget, i.type, s, i.options);
    });
  }, [
    r
  ]);
  return V(() => n, [
    n
  ]), {
    addGlobalListener: t,
    removeGlobalListener: r,
    removeAllGlobalListeners: n
  };
}
function sr(e, t) {
  let { id: r, "aria-label": n, "aria-labelledby": i } = e;
  return r = ae(r), i && n ? i = [
    .../* @__PURE__ */ new Set([
      r,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !n && !i && t && (n = t), {
    id: r,
    "aria-label": n,
    "aria-labelledby": i
  };
}
function lr(e) {
  const t = M(null);
  return te(() => ({
    get current() {
      return t.current;
    },
    set current(r) {
      t.current = r, typeof e == "function" ? e(r) : e && (e.current = r);
    }
  }), [
    e
  ]);
}
function ft(e, t) {
  ue(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Me(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : ct() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function ur(e) {
  return !ct() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
const pt = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], cr = pt.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
pt.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
function dr(e) {
  return e.matches(cr);
}
function bt(e, t = -1 / 0, r = 1 / 0) {
  return Math.min(Math.max(e, t), r);
}
const fr = Symbol("default");
function vt(e) {
  let { className: t, style: r, children: n, defaultClassName: i, defaultChildren: s, defaultStyle: l, values: u } = e;
  return te(() => {
    let c, f, p;
    return typeof t == "function" ? c = t({
      ...u,
      defaultClassName: i
    }) : c = t, typeof r == "function" ? f = r({
      ...u,
      defaultStyle: l || {}
    }) : f = r, typeof n == "function" ? p = n({
      ...u,
      defaultChildren: s
    }) : n == null ? p = s : p = n, {
      className: c ?? i,
      style: f || l ? {
        ...l,
        ...f
      } : void 0,
      children: p ?? s,
      "data-rac": ""
    };
  }, [
    t,
    r,
    n,
    i,
    s,
    l,
    u
  ]);
}
function pr(e, t) {
  let r = _(e);
  if (t === null)
    return null;
  if (r && typeof r == "object" && "slots" in r && r.slots) {
    let n = t || fr;
    if (!r.slots[n]) {
      let i = new Intl.ListFormat().format(Object.keys(r.slots).map((l) => `"${l}"`)), s = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${s} Valid slot names are ${i}.`);
    }
    return r.slots[n];
  }
  return r;
}
function $t(e, t, r) {
  let n = pr(r, e.slot) || {}, { ref: i, ...s } = n, l = lr(te(() => Yt(t, i), [
    t,
    i
  ])), u = U(s, e);
  return "style" in s && s.style && "style" in e && e.style && (typeof s.style == "function" || typeof e.style == "function" ? u.style = (c) => {
    let f = typeof s.style == "function" ? s.style(c) : s.style, p = {
      ...c.defaultStyle,
      ...f
    }, v = typeof e.style == "function" ? e.style({
      ...c,
      defaultStyle: p
    }) : e.style;
    return {
      ...p,
      ...v
    };
  } : u.style = {
    ...s.style,
    ...e.style
  }), [
    u,
    l
  ];
}
function br(e = !0) {
  let [t, r] = B(e), n = M(!1), i = N((s) => {
    n.current = !0, r(!!s);
  }, []);
  return ue(() => {
    n.current || r(!1);
  }, []), [
    i,
    t
  ];
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const vr = /* @__PURE__ */ he(!1);
function $r(e) {
  let t = (r, n) => _(vr) ? null : e(r, n);
  return t.displayName = e.displayName || e.name, it(t);
}
function We(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function gt(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function yt(e) {
  let t = M({
    isFocused: !1,
    observer: null
  });
  ue(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = G((n) => {
    e == null || e(n);
  });
  return N((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let i = n.target, s = (l) => {
        if (t.current.isFocused = !1, i.disabled) {
          let u = We(l);
          r(u);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      i.addEventListener("focusout", s, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && i.disabled) {
          var l;
          (l = t.current.observer) === null || l === void 0 || l.disconnect();
          let u = i === document.activeElement ? null : document.activeElement;
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: u
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: u
          }));
        }
      }), t.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
let $e = !1;
function ze(e) {
  for (; e && !dr(e); ) e = e.parentElement;
  let t = k(e), r = t.document.activeElement;
  if (!r || r === e) return;
  $e = !0;
  let n = !1, i = (p) => {
    (p.target === r || n) && p.stopImmediatePropagation();
  }, s = (p) => {
    (p.target === r || n) && (p.stopImmediatePropagation(), !e && !n && (n = !0, Q(r), c()));
  }, l = (p) => {
    (p.target === e || n) && p.stopImmediatePropagation();
  }, u = (p) => {
    (p.target === e || n) && (p.stopImmediatePropagation(), n || (n = !0, Q(r), c()));
  };
  t.addEventListener("blur", i, !0), t.addEventListener("focusout", s, !0), t.addEventListener("focusin", u, !0), t.addEventListener("focus", l, !0);
  let c = () => {
    cancelAnimationFrame(f), t.removeEventListener("blur", i, !0), t.removeEventListener("focusout", s, !0), t.removeEventListener("focusin", u, !0), t.removeEventListener("focus", l, !0), $e = !1, n = !1;
  }, f = requestAnimationFrame(c);
  return c;
}
let Z = "default", De = "", be = /* @__PURE__ */ new WeakMap();
function Xe(e) {
  if (Ue()) {
    if (Z === "default") {
      const t = F(e);
      De = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    Z = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    be.set(e, e.style[t]), e.style[t] = "none";
  }
}
function xe(e) {
  if (Ue()) {
    if (Z !== "disabled") return;
    Z = "restoring", setTimeout(() => {
      dt(() => {
        if (Z === "restoring") {
          const t = F(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = De || ""), De = "", Z = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && be.has(e)) {
    let t = be.get(e), r = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[r] === "none" && (e.style[r] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), be.delete(e);
  }
}
const mt = C.createContext({
  register: () => {
  }
});
mt.displayName = "PressResponderContext";
function gr(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function ht(e, t, r) {
  if (!t.has(e)) throw new TypeError("attempted to " + r + " private field on non-instance");
  return t.get(e);
}
function yr(e, t) {
  var r = ht(e, t, "get");
  return gr(e, r);
}
function mr(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function hr(e, t, r) {
  mr(e, t), t.set(e, r);
}
function Er(e, t, r) {
  if (t.set) t.set.call(e, r);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = r;
  }
}
function Ye(e, t, r) {
  var n = ht(e, t, "set");
  return Er(e, n, r), r;
}
function Pr(e) {
  let t = _(mt);
  if (t) {
    let { register: r, ...n } = t;
    e = U(n, e), r();
  }
  return ft(t, e.ref), e;
}
var fe = /* @__PURE__ */ new WeakMap();
class pe {
  continuePropagation() {
    Ye(this, fe, !1);
  }
  get shouldStopPropagation() {
    return yr(this, fe);
  }
  constructor(t, r, n, i) {
    hr(this, fe, {
      writable: !0,
      value: void 0
    }), Ye(this, fe, !0);
    var s;
    let l = (s = i == null ? void 0 : i.target) !== null && s !== void 0 ? s : n.currentTarget;
    const u = l == null ? void 0 : l.getBoundingClientRect();
    let c, f = 0, p, v = null;
    n.clientX != null && n.clientY != null && (p = n.clientX, v = n.clientY), u && (p != null && v != null ? (c = p - u.left, f = v - u.top) : (c = u.width / 2, f = u.height / 2)), this.type = t, this.pointerType = r, this.target = n.currentTarget, this.shiftKey = n.shiftKey, this.metaKey = n.metaKey, this.ctrlKey = n.ctrlKey, this.altKey = n.altKey, this.x = c, this.y = f;
  }
}
const qe = Symbol("linkClicked");
function Tr(e) {
  let { onPress: t, onPressChange: r, onPressStart: n, onPressEnd: i, onPressUp: s, onClick: l, isDisabled: u, isPressed: c, preventFocusOnPress: f, shouldCancelOnPointerExit: p, allowTextSelectionOnPress: v, ref: E, ...x } = Pr(e), [L, $] = B(!1), y = M({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: w, removeAllGlobalListeners: D } = je(), O = G((o, b) => {
    let S = y.current;
    if (u || S.didFirePressStart) return !1;
    let d = !0;
    if (S.isTriggeringEvent = !0, n) {
      let P = new pe("pressstart", b, o);
      n(P), d = P.shouldStopPropagation;
    }
    return r && r(!0), S.isTriggeringEvent = !1, S.didFirePressStart = !0, $(!0), d;
  }), I = G((o, b, S = !0) => {
    let d = y.current;
    if (!d.didFirePressStart) return !1;
    d.didFirePressStart = !1, d.isTriggeringEvent = !0;
    let P = !0;
    if (i) {
      let a = new pe("pressend", b, o);
      i(a), P = a.shouldStopPropagation;
    }
    if (r && r(!1), $(!1), t && S && !u) {
      let a = new pe("press", b, o);
      t(a), P && (P = a.shouldStopPropagation);
    }
    return d.isTriggeringEvent = !1, P;
  }), X = G((o, b) => {
    let S = y.current;
    if (u) return !1;
    if (s) {
      S.isTriggeringEvent = !0;
      let d = new pe("pressup", b, o);
      return s(d), S.isTriggeringEvent = !1, d.shouldStopPropagation;
    }
    return !0;
  }), H = G((o) => {
    let b = y.current;
    if (b.isPressed && b.target) {
      b.didFirePressStart && b.pointerType != null && I(Y(b.target, o), b.pointerType, !1), b.isPressed = !1, b.isOverTarget = !1, b.activePointerId = null, b.pointerType = null, D(), v || xe(b.target);
      for (let S of b.disposables) S();
      b.disposables = [];
    }
  }), ce = G((o) => {
    p && H(o);
  }), Pe = G((o) => {
    l == null || l(o);
  }), Te = G((o, b) => {
    if (l) {
      let S = new MouseEvent("click", o);
      gt(S, b), l(We(S));
    }
  }), Ot = te(() => {
    let o = y.current, b = {
      onKeyDown(d) {
        if (Le(d.nativeEvent, d.currentTarget) && T(d.currentTarget, m(d.nativeEvent))) {
          var P;
          Qe(m(d.nativeEvent), d.key) && d.preventDefault();
          let a = !0;
          if (!o.isPressed && !d.repeat) {
            o.target = d.currentTarget, o.isPressed = !0, o.pointerType = "keyboard", a = O(d, "keyboard");
            let g = d.currentTarget, h = (R) => {
              Le(R, g) && !R.repeat && T(g, m(R)) && o.target && X(Y(o.target, R), "keyboard");
            };
            w(F(d.currentTarget), "keyup", lt(h, S), !0);
          }
          a && d.stopPropagation(), d.metaKey && ee() && ((P = o.metaKeyEvents) === null || P === void 0 || P.set(d.key, d.nativeEvent));
        } else d.key === "Meta" && (o.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(d) {
        if (!(d && !T(d.currentTarget, m(d.nativeEvent))) && d && d.button === 0 && !o.isTriggeringEvent && !le.isOpening) {
          let P = !0;
          if (u && d.preventDefault(), !o.ignoreEmulatedMouseEvents && !o.isPressed && (o.pointerType === "virtual" || Me(d.nativeEvent))) {
            let a = O(d, "virtual"), g = X(d, "virtual"), h = I(d, "virtual");
            Pe(d), P = a && g && h;
          } else if (o.isPressed && o.pointerType !== "keyboard") {
            let a = o.pointerType || d.nativeEvent.pointerType || "virtual";
            P = I(Y(d.currentTarget, d), a, !0), o.isOverTarget = !1, Pe(d), H(d);
          }
          o.ignoreEmulatedMouseEvents = !1, P && d.stopPropagation();
        }
      }
    }, S = (d) => {
      var P;
      if (o.isPressed && o.target && Le(d, o.target)) {
        var a;
        Qe(m(d), d.key) && d.preventDefault();
        let h = m(d), R = T(o.target, m(d));
        I(Y(o.target, d), "keyboard", R), R && Te(d, o.target), D(), d.key !== "Enter" && Ge(o.target) && T(o.target, h) && !d[qe] && (d[qe] = !0, le(o.target, d, !1)), o.isPressed = !1, (a = o.metaKeyEvents) === null || a === void 0 || a.delete(d.key);
      } else if (d.key === "Meta" && (!((P = o.metaKeyEvents) === null || P === void 0) && P.size)) {
        var g;
        let h = o.metaKeyEvents;
        o.metaKeyEvents = void 0;
        for (let R of h.values()) (g = o.target) === null || g === void 0 || g.dispatchEvent(new KeyboardEvent("keyup", R));
      }
    };
    if (typeof PointerEvent < "u") {
      b.onPointerDown = (a) => {
        if (a.button !== 0 || !T(a.currentTarget, m(a.nativeEvent))) return;
        if (ur(a.nativeEvent)) {
          o.pointerType = "virtual";
          return;
        }
        o.pointerType = a.pointerType;
        let g = !0;
        if (!o.isPressed) {
          o.isPressed = !0, o.isOverTarget = !0, o.activePointerId = a.pointerId, o.target = a.currentTarget, v || Xe(o.target), g = O(a, o.pointerType);
          let h = m(a.nativeEvent);
          "releasePointerCapture" in h && h.releasePointerCapture(a.pointerId), w(F(a.currentTarget), "pointerup", d, !1), w(F(a.currentTarget), "pointercancel", P, !1);
        }
        g && a.stopPropagation();
      }, b.onMouseDown = (a) => {
        if (T(a.currentTarget, m(a.nativeEvent)) && a.button === 0) {
          if (f) {
            let g = ze(a.target);
            g && o.disposables.push(g);
          }
          a.stopPropagation();
        }
      }, b.onPointerUp = (a) => {
        !T(a.currentTarget, m(a.nativeEvent)) || o.pointerType === "virtual" || a.button === 0 && X(a, o.pointerType || a.pointerType);
      }, b.onPointerEnter = (a) => {
        a.pointerId === o.activePointerId && o.target && !o.isOverTarget && o.pointerType != null && (o.isOverTarget = !0, O(Y(o.target, a), o.pointerType));
      }, b.onPointerLeave = (a) => {
        a.pointerId === o.activePointerId && o.target && o.isOverTarget && o.pointerType != null && (o.isOverTarget = !1, I(Y(o.target, a), o.pointerType, !1), ce(a));
      };
      let d = (a) => {
        if (a.pointerId === o.activePointerId && o.isPressed && a.button === 0 && o.target) {
          if (T(o.target, m(a)) && o.pointerType != null) {
            let g = !1, h = setTimeout(() => {
              o.isPressed && o.target instanceof HTMLElement && (g ? H(a) : (Q(o.target), o.target.click()));
            }, 80);
            w(a.currentTarget, "click", () => g = !0, !0), o.disposables.push(() => clearTimeout(h));
          } else H(a);
          o.isOverTarget = !1;
        }
      }, P = (a) => {
        H(a);
      };
      b.onDragStart = (a) => {
        T(a.currentTarget, m(a.nativeEvent)) && H(a);
      };
    } else if (process.env.NODE_ENV === "test") {
      b.onMouseDown = (a) => {
        if (a.button !== 0 || !T(a.currentTarget, m(a.nativeEvent))) return;
        if (o.ignoreEmulatedMouseEvents) {
          a.stopPropagation();
          return;
        }
        if (o.isPressed = !0, o.isOverTarget = !0, o.target = a.currentTarget, o.pointerType = Me(a.nativeEvent) ? "virtual" : "mouse", kt(() => O(a, o.pointerType)) && a.stopPropagation(), f) {
          let h = ze(a.target);
          h && o.disposables.push(h);
        }
        w(F(a.currentTarget), "mouseup", d, !1);
      }, b.onMouseEnter = (a) => {
        if (!T(a.currentTarget, m(a.nativeEvent))) return;
        let g = !0;
        o.isPressed && !o.ignoreEmulatedMouseEvents && o.pointerType != null && (o.isOverTarget = !0, g = O(a, o.pointerType)), g && a.stopPropagation();
      }, b.onMouseLeave = (a) => {
        if (!T(a.currentTarget, m(a.nativeEvent))) return;
        let g = !0;
        o.isPressed && !o.ignoreEmulatedMouseEvents && o.pointerType != null && (o.isOverTarget = !1, g = I(a, o.pointerType, !1), ce(a)), g && a.stopPropagation();
      }, b.onMouseUp = (a) => {
        T(a.currentTarget, m(a.nativeEvent)) && !o.ignoreEmulatedMouseEvents && a.button === 0 && X(a, o.pointerType || "mouse");
      };
      let d = (a) => {
        if (a.button === 0) {
          if (o.ignoreEmulatedMouseEvents) {
            o.ignoreEmulatedMouseEvents = !1;
            return;
          }
          o.target && o.target.contains(a.target) && o.pointerType != null || H(a), o.isOverTarget = !1;
        }
      };
      b.onTouchStart = (a) => {
        if (!T(a.currentTarget, m(a.nativeEvent))) return;
        let g = wr(a.nativeEvent);
        if (!g) return;
        o.activePointerId = g.identifier, o.ignoreEmulatedMouseEvents = !0, o.isOverTarget = !0, o.isPressed = !0, o.target = a.currentTarget, o.pointerType = "touch", v || Xe(o.target), O(W(o.target, a), o.pointerType) && a.stopPropagation(), w(k(a.currentTarget), "scroll", P, !0);
      }, b.onTouchMove = (a) => {
        if (!T(a.currentTarget, m(a.nativeEvent))) return;
        if (!o.isPressed) {
          a.stopPropagation();
          return;
        }
        let g = Ze(a.nativeEvent, o.activePointerId), h = !0;
        g && Je(g, a.currentTarget) ? !o.isOverTarget && o.pointerType != null && (o.isOverTarget = !0, h = O(W(o.target, a), o.pointerType)) : o.isOverTarget && o.pointerType != null && (o.isOverTarget = !1, h = I(W(o.target, a), o.pointerType, !1), ce(W(o.target, a))), h && a.stopPropagation();
      }, b.onTouchEnd = (a) => {
        if (!T(a.currentTarget, m(a.nativeEvent))) return;
        if (!o.isPressed) {
          a.stopPropagation();
          return;
        }
        let g = Ze(a.nativeEvent, o.activePointerId), h = !0;
        g && Je(g, a.currentTarget) && o.pointerType != null ? (X(W(o.target, a), o.pointerType), h = I(W(o.target, a), o.pointerType), Te(a.nativeEvent, o.target)) : o.isOverTarget && o.pointerType != null && (h = I(W(o.target, a), o.pointerType, !1)), h && a.stopPropagation(), o.isPressed = !1, o.activePointerId = null, o.isOverTarget = !1, o.ignoreEmulatedMouseEvents = !0, o.target && !v && xe(o.target), D();
      }, b.onTouchCancel = (a) => {
        T(a.currentTarget, m(a.nativeEvent)) && (a.stopPropagation(), o.isPressed && H(W(o.target, a)));
      };
      let P = (a) => {
        o.isPressed && T(m(a), o.target) && H({
          currentTarget: o.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      b.onDragStart = (a) => {
        T(a.currentTarget, m(a.nativeEvent)) && H(a);
      };
    }
    return b;
  }, [
    w,
    u,
    f,
    D,
    v,
    H,
    ce,
    I,
    O,
    X,
    Pe,
    Te
  ]);
  return V(() => {
    let o = E == null ? void 0 : E.current;
    o && o instanceof k(o).Element && k(o).getComputedStyle(o).touchAction === "auto" && (o.style.touchAction = "pan-x pan-y pinch-zoom");
  }, [
    E
  ]), V(() => {
    let o = y.current;
    return () => {
      var b;
      v || xe((b = o.target) !== null && b !== void 0 ? b : void 0);
      for (let S of o.disposables) S();
      o.disposables = [];
    };
  }, [
    v
  ]), {
    isPressed: c || L,
    pressProps: U(x, Ot)
  };
}
function Ge(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Le(e, t) {
  const { key: r, code: n } = e, i = t, s = i.getAttribute("role");
  return (r === "Enter" || r === " " || r === "Spacebar" || n === "Space") && !(i instanceof k(i).HTMLInputElement && !Et(i, r) || i instanceof k(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((s === "link" || !s && Ge(i)) && r !== "Enter");
}
function wr(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function Ze(e, t) {
  const r = e.changedTouches;
  for (let n = 0; n < r.length; n++) {
    const i = r[n];
    if (i.identifier === t) return i;
  }
  return null;
}
function W(e, t) {
  let r = 0, n = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (r = t.targetTouches[0].clientX, n = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: r,
    clientY: n
  };
}
function Y(e, t) {
  let r = t.clientX, n = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: r,
    clientY: n
  };
}
function xr(e) {
  let t = 0, r = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? r = e.height / 2 : e.radiusY !== void 0 && (r = e.radiusY), {
    top: e.clientY - r,
    right: e.clientX + t,
    bottom: e.clientY + r,
    left: e.clientX - t
  };
}
function Lr(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function Je(e, t) {
  let r = t.getBoundingClientRect(), n = xr(e);
  return Lr(r, n);
}
function Sr(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Ge(e);
}
function Qe(e, t) {
  return e instanceof HTMLInputElement ? !Et(e, t) : Sr(e);
}
const Fr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Et(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : Fr.has(e.type);
}
let re = null, Oe = /* @__PURE__ */ new Set(), oe = /* @__PURE__ */ new Map(), z = !1, ke = !1;
const Cr = {
  Tab: !0,
  Escape: !0
};
function Be(e, t) {
  for (let r of Oe) r(e, t);
}
function Mr(e) {
  return !(e.metaKey || !ee() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function ge(e) {
  z = !0, Mr(e) && (re = "keyboard", Be("keyboard", e));
}
function K(e) {
  re = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (z = !0, Be("pointer", e));
}
function Pt(e) {
  Me(e) && (z = !0, re = "virtual");
}
function Tt(e) {
  e.target === window || e.target === document || $e || !e.isTrusted || (!z && !ke && (re = "virtual", Be("virtual", e)), z = !1, ke = !1);
}
function wt() {
  $e || (z = !1, ke = !0);
}
function Ie(e) {
  if (typeof window > "u" || oe.get(k(e))) return;
  const t = k(e), r = F(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    z = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", ge, !0), r.addEventListener("keyup", ge, !0), r.addEventListener("click", Pt, !0), t.addEventListener("focus", Tt, !0), t.addEventListener("blur", wt, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", K, !0), r.addEventListener("pointermove", K, !0), r.addEventListener("pointerup", K, !0)) : process.env.NODE_ENV === "test" && (r.addEventListener("mousedown", K, !0), r.addEventListener("mousemove", K, !0), r.addEventListener("mouseup", K, !0)), t.addEventListener("beforeunload", () => {
    xt(e);
  }, {
    once: !0
  }), oe.set(t, {
    focus: n
  });
}
const xt = (e, t) => {
  const r = k(e), n = F(e);
  t && n.removeEventListener("DOMContentLoaded", t), oe.has(r) && (r.HTMLElement.prototype.focus = oe.get(r).focus, n.removeEventListener("keydown", ge, !0), n.removeEventListener("keyup", ge, !0), n.removeEventListener("click", Pt, !0), r.removeEventListener("focus", Tt, !0), r.removeEventListener("blur", wt, !1), typeof PointerEvent < "u" ? (n.removeEventListener("pointerdown", K, !0), n.removeEventListener("pointermove", K, !0), n.removeEventListener("pointerup", K, !0)) : process.env.NODE_ENV === "test" && (n.removeEventListener("mousedown", K, !0), n.removeEventListener("mousemove", K, !0), n.removeEventListener("mouseup", K, !0)), oe.delete(r));
};
function Dr(e) {
  const t = F(e);
  let r;
  return t.readyState !== "loading" ? Ie(e) : (r = () => {
    Ie(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => xt(e, r);
}
typeof document < "u" && Dr();
function Lt() {
  return re !== "pointer";
}
function Or() {
  return re;
}
const kr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ir(e, t, r) {
  let n = F(r == null ? void 0 : r.target);
  const i = typeof window < "u" ? k(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, s = typeof window < "u" ? k(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, l = typeof window < "u" ? k(r == null ? void 0 : r.target).HTMLElement : HTMLElement, u = typeof window < "u" ? k(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || n.activeElement instanceof i && !kr.has(n.activeElement.type) || n.activeElement instanceof s || n.activeElement instanceof l && n.activeElement.isContentEditable, !(e && t === "keyboard" && r instanceof u && !Cr[r.key]);
}
function Kr(e, t, r) {
  Ie(), V(() => {
    let n = (i, s) => {
      Ir(!!(r != null && r.isTextInput), i, s) && e(Lt());
    };
    return Oe.add(n), () => {
      Oe.delete(n);
    };
  }, t);
}
function Nr(e) {
  const t = F(e), r = se(t);
  if (Or() === "virtual") {
    let n = r;
    dt(() => {
      se(t) === n && e.isConnected && Q(e);
    });
  } else Q(e);
}
function St(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: i } = e;
  const s = N((c) => {
    if (c.target === c.currentTarget)
      return n && n(c), i && i(!1), !0;
  }, [
    n,
    i
  ]), l = yt(s), u = N((c) => {
    const f = F(c.target), p = f ? se(f) : se();
    c.target === c.currentTarget && p === m(c.nativeEvent) && (r && r(c), i && i(!0), l(c));
  }, [
    i,
    r,
    l
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || i || n) ? u : void 0,
      onBlur: !t && (n || i) ? s : void 0
    }
  };
}
function et(e) {
  if (!e) return;
  let t = !0;
  return (r) => {
    let n = {
      ...r,
      preventDefault() {
        r.preventDefault();
      },
      isDefaultPrevented() {
        return r.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(n), t && r.stopPropagation();
  };
}
function Hr(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: et(e.onKeyDown),
      onKeyUp: et(e.onKeyUp)
    }
  };
}
let Ar = /* @__PURE__ */ C.createContext(null);
function Vr(e) {
  let t = _(Ar) || {};
  ft(t, e);
  let { ref: r, ...n } = t;
  return n;
}
function Rr(e, t) {
  let { focusProps: r } = St(e), { keyboardProps: n } = Hr(e), i = U(r, n), s = Vr(t), l = e.isDisabled ? {} : s, u = M(e.autoFocus);
  V(() => {
    u.current && t.current && Nr(t.current), u.current = !1;
  }, [
    t
  ]);
  let c = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (c = void 0), {
    focusableProps: U({
      ...i,
      tabIndex: c
    }, l)
  };
}
function Ur(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: i } = e, s = M({
    isFocusWithin: !1
  }), { addGlobalListener: l, removeAllGlobalListeners: u } = je(), c = N((v) => {
    v.currentTarget.contains(v.target) && s.current.isFocusWithin && !v.currentTarget.contains(v.relatedTarget) && (s.current.isFocusWithin = !1, u(), r && r(v), i && i(!1));
  }, [
    r,
    i,
    s,
    u
  ]), f = yt(c), p = N((v) => {
    if (!v.currentTarget.contains(v.target)) return;
    const E = F(v.target), x = se(E);
    if (!s.current.isFocusWithin && x === m(v.nativeEvent)) {
      n && n(v), i && i(!0), s.current.isFocusWithin = !0, f(v);
      let L = v.currentTarget;
      l(E, "focus", ($) => {
        if (s.current.isFocusWithin && !T(L, $.target)) {
          let y = new E.defaultView.FocusEvent("blur", {
            relatedTarget: $.target
          });
          gt(y, L);
          let w = We(y);
          c(w);
        }
      }, {
        capture: !0
      });
    }
  }, [
    n,
    i,
    f,
    l,
    c
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: p,
      onBlur: c
    }
  };
}
let ye = !1, Se = 0;
function Ke() {
  ye = !0, setTimeout(() => {
    ye = !1;
  }, 50);
}
function tt(e) {
  e.pointerType === "touch" && Ke();
}
function jr() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", tt) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", Ke), Se++, () => {
      Se--, !(Se > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", tt) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", Ke));
    };
}
function Wr(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: n, isDisabled: i } = e, [s, l] = B(!1), u = M({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  V(jr, []);
  let { addGlobalListener: c, removeAllGlobalListeners: f } = je(), { hoverProps: p, triggerHoverEnd: v } = te(() => {
    let E = ($, y) => {
      if (u.pointerType = y, i || y === "touch" || u.isHovered || !$.currentTarget.contains($.target)) return;
      u.isHovered = !0;
      let w = $.currentTarget;
      u.target = w, c(F($.target), "pointerover", (D) => {
        u.isHovered && u.target && !T(u.target, D.target) && x(D, D.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: w,
        pointerType: y
      }), r && r(!0), l(!0);
    }, x = ($, y) => {
      let w = u.target;
      u.pointerType = "", u.target = null, !(y === "touch" || !u.isHovered || !w) && (u.isHovered = !1, f(), n && n({
        type: "hoverend",
        target: w,
        pointerType: y
      }), r && r(!1), l(!1));
    }, L = {};
    return typeof PointerEvent < "u" ? (L.onPointerEnter = ($) => {
      ye && $.pointerType === "mouse" || E($, $.pointerType);
    }, L.onPointerLeave = ($) => {
      !i && $.currentTarget.contains($.target) && x($, $.pointerType);
    }) : process.env.NODE_ENV === "test" && (L.onTouchStart = () => {
      u.ignoreEmulatedMouseEvents = !0;
    }, L.onMouseEnter = ($) => {
      !u.ignoreEmulatedMouseEvents && !ye && E($, "mouse"), u.ignoreEmulatedMouseEvents = !1;
    }, L.onMouseLeave = ($) => {
      !i && $.currentTarget.contains($.target) && x($, "mouse");
    }), {
      hoverProps: L,
      triggerHoverEnd: x
    };
  }, [
    t,
    r,
    n,
    i,
    u,
    c,
    f
  ]);
  return V(() => {
    i && v({
      currentTarget: u.target
    }, u.pointerType);
  }, [
    i
  ]), {
    hoverProps: p,
    isHovered: s
  };
}
const Gr = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Br = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function _r(e) {
  if (Intl.Locale) {
    let r = new Intl.Locale(e).maximize(), n = typeof r.getTextInfo == "function" ? r.getTextInfo() : r.textInfo;
    if (n) return n.direction === "rtl";
    if (r.script) return Gr.has(r.script);
  }
  let t = e.split("-")[0];
  return Br.has(t);
}
const zr = Symbol.for("react-aria.i18n.locale");
function Ft() {
  let e = typeof window < "u" && window[zr] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: _r(e) ? "rtl" : "ltr"
  };
}
let Ne = Ft(), ie = /* @__PURE__ */ new Set();
function rt() {
  Ne = Ft();
  for (let e of ie) e(Ne);
}
function Xr() {
  let e = st(), [t, r] = B(Ne);
  return V(() => (ie.size === 0 && window.addEventListener("languagechange", rt), ie.add(r), () => {
    ie.delete(r), ie.size === 0 && window.removeEventListener("languagechange", rt);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Yr = /* @__PURE__ */ C.createContext(null);
function qr() {
  let e = Xr();
  return _(Yr) || e;
}
let Fe = /* @__PURE__ */ new Map(), He = !1;
try {
  He = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let me = !1;
try {
  me = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Ct = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Zr {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let r = "";
    if (!He && this.options.signDisplay != null ? r = Qr(this.numberFormatter, this.options.signDisplay, t) : r = this.numberFormatter.format(t), this.options.style === "unit" && !me) {
      var n;
      let { unit: i, unitDisplay: s = "short", locale: l } = this.resolvedOptions();
      if (!i) return r;
      let u = (n = Ct[i]) === null || n === void 0 ? void 0 : n[s];
      r += u[l] || u.default;
    }
    return r;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, r) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(r)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, r) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    let n = this.numberFormatter.formatToParts(t), i = this.numberFormatter.formatToParts(r);
    return [
      ...n.map((s) => ({
        ...s,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...i.map((s) => ({
        ...s,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !He && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !me && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, r = {}) {
    this.numberFormatter = Jr(t, r), this.options = r;
  }
}
function Jr(e, t = {}) {
  let { numberingSystem: r } = t;
  if (r && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${r}`), t.style === "unit" && !me) {
    var n;
    let { unit: l, unitDisplay: u = "short" } = t;
    if (!l) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((n = Ct[l]) === null || n === void 0) && n[u])) throw new Error(`Unsupported unit ${l} with unitDisplay = ${u}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let i = e + (t ? Object.entries(t).sort((l, u) => l[0] < u[0] ? -1 : 1).join() : "");
  if (Fe.has(i)) return Fe.get(i);
  let s = new Intl.NumberFormat(e, t);
  return Fe.set(i, s), s;
}
function Qr(e, t, r) {
  if (t === "auto") return e.format(r);
  if (t === "never") return e.format(Math.abs(r));
  {
    let n = !1;
    if (t === "always" ? n = r > 0 || Object.is(r, 0) : t === "exceptZero" && (Object.is(r, -0) || Object.is(r, 0) ? r = Math.abs(r) : n = r > 0), n) {
      let i = e.format(-r), s = e.format(r), l = i.replace(s, "").replace(/\u200e|\u061C/, "");
      return [
        ...l
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), i.replace(s, "!!!").replace(l, "+").replace("!!!", s);
    } else return e.format(r);
  }
}
function en(e = {}) {
  let { locale: t } = qr();
  return te(() => new Zr(t, e), [
    t,
    e
  ]);
}
function tn(e, t) {
  let { elementType: r = "button", isDisabled: n, onPress: i, onPressStart: s, onPressEnd: l, onPressUp: u, onPressChange: c, preventFocusOnPress: f, allowFocusWhenDisabled: p, onClick: v, href: E, target: x, rel: L, type: $ = "button" } = e, y;
  r === "button" ? y = {
    type: $,
    disabled: n
  } : y = {
    role: "button",
    href: r === "a" && !n ? E : void 0,
    target: r === "a" ? x : void 0,
    type: r === "input" ? $ : void 0,
    disabled: r === "input" ? n : void 0,
    "aria-disabled": !n || r === "input" ? void 0 : n,
    rel: r === "a" ? L : void 0
  };
  let { pressProps: w, isPressed: D } = Tr({
    onPressStart: s,
    onPressEnd: l,
    onPressChange: c,
    onPress: i,
    onPressUp: u,
    onClick: v,
    isDisabled: n,
    preventFocusOnPress: f,
    ref: t
  }), { focusableProps: O } = Rr(e, t);
  p && (O.tabIndex = n ? -1 : O.tabIndex);
  let I = U(O, w, Ve(e, {
    labelable: !0
  }));
  return {
    isPressed: D,
    buttonProps: U(y, I, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"]
    })
  };
}
function rn(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, i = M({
    isFocused: !1,
    isFocusVisible: t || Lt()
  }), [s, l] = B(!1), [u, c] = B(() => i.current.isFocused && i.current.isFocusVisible), f = N(() => c(i.current.isFocused && i.current.isFocusVisible), []), p = N((x) => {
    i.current.isFocused = x, l(x), f();
  }, [
    f
  ]);
  Kr((x) => {
    i.current.isFocusVisible = x, f();
  }, [], {
    isTextInput: r
  });
  let { focusProps: v } = St({
    isDisabled: n,
    onFocusChange: p
  }), { focusWithinProps: E } = Ur({
    isDisabled: !n,
    onFocusWithinChange: p
  });
  return {
    isFocused: s,
    isFocusVisible: u,
    focusProps: n ? E : v
  };
}
const Mt = 7e3;
let A = null;
function nt(e, t = "assertive", r = Mt) {
  A ? A.announce(e, t, r) : (A = new nn(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? A.announce(e, t, r) : setTimeout(() => {
    A != null && A.isAttached() && (A == null || A.announce(e, t, r));
  }, 100));
}
class nn {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let r = document.createElement("div");
    return r.setAttribute("role", "log"), r.setAttribute("aria-live", t), r.setAttribute("aria-relevant", "additions"), r;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, r = "assertive", n = Mt) {
    var i, s;
    if (!this.node) return;
    let l = document.createElement("div");
    typeof t == "object" ? (l.setAttribute("role", "img"), l.setAttribute("aria-labelledby", t["aria-labelledby"])) : l.textContent = t, r === "assertive" ? (i = this.assertiveLog) === null || i === void 0 || i.appendChild(l) : (s = this.politeLog) === null || s === void 0 || s.appendChild(l), t !== "" && setTimeout(() => {
      l.remove();
    }, n);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
function on(e) {
  let { id: t, label: r, "aria-labelledby": n, "aria-label": i, labelElementType: s = "label" } = e;
  t = ae(t);
  let l = ae(), u = {};
  r ? (n = n ? `${l} ${n}` : l, u = {
    id: l,
    htmlFor: s === "label" ? t : void 0
  }) : !n && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let c = sr({
    id: t,
    "aria-label": i,
    "aria-labelledby": n
  });
  return {
    labelProps: u,
    fieldProps: c
  };
}
function an(e) {
  let { value: t = 0, minValue: r = 0, maxValue: n = 100, valueLabel: i, isIndeterminate: s, formatOptions: l = {
    style: "percent"
  } } = e, u = Ve(e, {
    labelable: !0
  }), { labelProps: c, fieldProps: f } = on({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = bt(t, r, n);
  let p = (t - r) / (n - r), v = en(l);
  if (!s && !i) {
    let E = l.style === "percent" ? p : t;
    i = v.format(E);
  }
  return {
    progressBarProps: U(u, {
      ...f,
      "aria-valuenow": s ? void 0 : t,
      "aria-valuemin": r,
      "aria-valuemax": n,
      "aria-valuetext": s ? void 0 : i,
      role: "progressbar"
    }),
    labelProps: c
  };
}
const sn = /* @__PURE__ */ he({}), Dt = /* @__PURE__ */ he(null), pn = /* @__PURE__ */ it(function(t, r) {
  [t, r] = $t(t, r, Dt);
  let { value: n = 0, minValue: i = 0, maxValue: s = 100, isIndeterminate: l = !1 } = t;
  n = bt(n, i, s);
  let [u, c] = br(!t["aria-label"] && !t["aria-labelledby"]), { progressBarProps: f, labelProps: p } = an({
    ...t,
    label: c
  }), v = l ? void 0 : (n - i) / (s - i) * 100, E = vt({
    ...t,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: v,
      valueText: f["aria-valuetext"],
      isIndeterminate: l
    }
  });
  return /* @__PURE__ */ C.createElement("div", {
    ...f,
    ...E,
    ref: r,
    slot: t.slot || void 0
  }, /* @__PURE__ */ C.createElement(sn.Provider, {
    value: {
      ...p,
      ref: u,
      elementType: "span"
    }
  }, E.children));
}), ln = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), un = /* @__PURE__ */ he({}), bn = /* @__PURE__ */ $r(function(t, r) {
  [t, r] = $t(t, r, un), t = cn(t);
  let n = t, { isPending: i } = n, { buttonProps: s, isPressed: l } = tn(t, r), { focusProps: u, isFocused: c, isFocusVisible: f } = rn(t), { hoverProps: p, isHovered: v } = Wr({
    ...t,
    isDisabled: t.isDisabled || i
  }), E = {
    isHovered: v,
    isPressed: (n.isPressed || l) && !i,
    isFocused: c,
    isFocusVisible: f,
    isDisabled: t.isDisabled || !1,
    isPending: i ?? !1
  }, x = vt({
    ...t,
    values: E,
    defaultClassName: "react-aria-Button"
  }), L = ae(s.id), $ = ae(), y = s["aria-labelledby"];
  i && (y ? y = `${y} ${$}` : s["aria-label"] && (y = `${L} ${$}`));
  let w = M(i);
  return V(() => {
    let D = {
      "aria-labelledby": y || L
    };
    (!w.current && c && i || w.current && c && !i) && nt(D, "assertive"), w.current = i;
  }, [
    i,
    c,
    y,
    L
  ]), /* @__PURE__ */ C.createElement("button", {
    ...Ve(t, {
      propNames: ln
    }),
    ...U(s, u, p),
    ...x,
    type: s.type === "submit" && i ? "button" : s.type,
    id: L,
    ref: r,
    "aria-labelledby": y,
    slot: t.slot || void 0,
    "aria-disabled": i ? "true" : s["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": E.isPressed || void 0,
    "data-hovered": v || void 0,
    "data-focused": c || void 0,
    "data-pending": i || void 0,
    "data-focus-visible": f || void 0
  }, /* @__PURE__ */ C.createElement(Dt.Provider, {
    value: {
      id: $
    }
  }, x.children));
});
function cn(e) {
  return e.isPending && (e.onPress = void 0, e.onPressStart = void 0, e.onPressEnd = void 0, e.onPressChange = void 0, e.onPressUp = void 0, e.onKeyDown = void 0, e.onKeyUp = void 0, e.onClick = void 0, e.href = void 0), e;
}
export {
  pn as $,
  bn as a,
  It as c
};
//# sourceMappingURL=vendor-D9Nsxj9p.js.map
